import { render } from "./PosDailyCollectionsReport.vue?vue&type=template&id=4e3d1470&scoped=true"
import script from "./PosDailyCollectionsReport.vue?vue&type=script&lang=js"
export * from "./PosDailyCollectionsReport.vue?vue&type=script&lang=js"

import "./PosDailyCollectionsReport.vue?vue&type=style&index=0&id=4e3d1470&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3d1470"]])

export default __exports__